<template>
  <div class="venue-coach-details coach-detail">
    <layouts-header></layouts-header>

    <!-- Banner -->
    <div class="banner">
      <img src="@/assets/img/bg/coach-detail-bg.jpg" alt="Banner" />
    </div>

    <!-- Page Content -->
    <div class="content">
      <div class="container">
        <!-- Row -->
        <div class="row move-top">
          <div class="col-12 col-sm-12 col-md-12 col-lg-8">
            <div
              class="dull-bg corner-radius-10 coach-info d-md-flex justify-content-start align-items-start"
            >
              <div class="profile-pic">
                <a href="javascript:void(0);"
                  ><img
                    alt="User"
                    class="corner-radius-10"
                    src="@/assets/img/profiles/avatar-coach-detail.jpg"
                /></a>
              </div>
              <div class="info w-100">
                <div class="d-sm-flex justify-content-between align-items-start">
                  <h3 class="d-flex align-items-center justify-content-start mb-0">
                    Kevin Anderson<span
                      class="d-flex justify-content-center align-items-center"
                      ><i class="fas fa-check-double"></i
                    ></span>
                  </h3>
                  <a href="javascript:;"
                    ><span class="favourite fav-icon"
                      ><i class="feather-star"></i>Favourite</span
                    ></a
                  >
                </div>
                <p>
                  Coach Kevin provides Badminton lessons in Santa Monica at Penmar Park
                </p>
                <ul class="d-sm-flex align-items-center">
                  <li class="d-flex align-items-center">
                    <div class="white-bg d-flex align-items-center review">
                      <span class="white-bg dark-yellow-bg d-flex align-items-center"
                        >4.5</span
                      ><span>300 Reviews</span>
                    </div>
                  </li>
                  <li>
                    <img src="@/assets/img/icons/flag-01.png" alt="Icon" />Santamanica,
                    United States
                  </li>
                </ul>
                <hr />
                <ul class="d-xl-flex">
                  <li class="d-flex align-items-center">
                    <img src="@/assets/img/icons/expert.svg" alt="Icon" />Rank : Expert
                  </li>
                  <li class="d-flex align-items-center">
                    <img src="@/assets/img/icons/sessions.svg" alt="Icon" />Sessions
                    Completed : 25
                  </li>
                  <li class="d-flex align-items-center">
                    <img src="@/assets/img/icons/since.svg" alt="Icon" />With Dreamsports
                    Since Apr 5, 2023
                  </li>
                </ul>
              </div>
            </div>
            <div class="venue-options white-bg mb-4">
              <ul class="clearfix">
                <li class="active"><a href="#short-bio">Short Bio</a></li>
                <li><a href="#lesson-with-me">Lesson With Me</a></li>
                <li><a href="#coaching">Coaching</a></li>
                <li><a href="#gallery">Gallery</a></li>
                <li><a href="#reviews">Reviews</a></li>
                <li><a href="#location">Locations</a></li>
              </ul>
            </div>

            <!-- Accordian Contents -->
            <div class="accordion" id="accordionPanel">
              <div class="accordion-item mb-4" id="short-bio">
                <h4 class="accordion-header" id="panelsStayOpen-short-bio">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    Short Bio
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-short-bio"
                >
                  <div class="accordion-body">
                    <div class="text show-more-height">
                      <p class="mb-0">Name: Kevin Anderson</p>
                      <p class="mb-4">
                        Experience: 10 years of experience coaching badminton at various
                        skill levels.
                      </p>
                      <p>
                        Credentials: Certified Badminton Coach with a deep understanding
                        of the sport's techniques and strategies. Coaching Style: Patient
                        and detail-oriented approach, focusing on technique refinement and
                        strategic gameplay. Achievements: Successfully guided players to
                        notable achievements in regional and national competitions.
                        Passion: An avid badminton enthusiast,Kevin is dedicated to
                        nurturing talent and fostering a love for the sport. Join Kevin’s
                        coaching sessions to enhance your badminton skills and unleash
                        your full potential.
                      </p>
                    </div>
                    <div class="show-more d align-items-center primary-text">
                      <i class="feather-plus-circle"></i>Show More
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item mb-4" id="lesson-with-me">
                <h4 class="accordion-header" id="panelsStayOpen-lesson-with-me">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    Lesson With Me
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseTwo"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-lesson-with-me"
                >
                  <div class="accordion-body">
                    <p>
                      Join me for personalized lessons tailored to your needs. Choose from
                      individual, 2-player, or group lessons for a customized badminton
                      experience.Heighten your skills and relish the process of getting
                      better.
                    </p>
                    <ul class="clearfix">
                      <li><i class="feather-check-square"></i>Single Lesson</li>
                      <li><i class="feather-check-square"></i>2 Player Lesson</li>
                      <li><i class="feather-check-square"></i>Small Group Lesson</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item mb-4" id="coaching">
                <h4 class="accordion-header" id="panelsStayOpen-coaching">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    Coaching
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseThree"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-coaching"
                >
                  <div class="accordion-body">
                    <p>
                      Experience transformative coaching tailored to your needs. Whether
                      individual, partner, or small group sessions, unlock your potential
                      with personalized instruction for success.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item mb-4" id="gallery">
                <h4 class="accordion-header" id="panelsStayOpen-gallery">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseFive"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseFive"
                  >
                    Gallery
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseFive"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-gallery"
                >
                  <div class="accordion-body">
                    <div class="owl-carousel gallery-slider owl-theme">
                      <coach-detail-carousel></coach-detail-carousel>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item mb-4" id="reviews">
                <div class="accordion-header" id="panelsStayOpen-reviews">
                  <div
                    class="accordion-button d-flex justify-content-between align-items-center"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseSix"
                    aria-controls="panelsStayOpen-collapseSix"
                  >
                    <span class="w-75 mb-0"> Reviews </span>
                  </div>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-gradient pull-right write-review add-review"
                    data-bs-toggle="modal"
                    data-bs-target="#add-review"
                    >Write a review</a
                  >
                </div>
                <div
                  id="panelsStayOpen-collapseSix"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-reviews"
                >
                  <div class="accordion-body">
                    <div class="row review-wrapper">
                      <div class="col-lg-3">
                        <div class="ratings-info corner-radius-10 text-center">
                          <h3>4.8</h3>
                          <span>out of 5.0</span>
                          <div class="rating">
                            <i class="fas fa-star filled"></i>
                            <i class="fas fa-star filled"></i>
                            <i class="fas fa-star filled"></i>
                            <i class="fas fa-star filled"></i>
                            <i class="fas fa-star filled"></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-9">
                        <div class="recommended">
                          <h5>Recommended by 97% of Players</h5>
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
                              <p class="mb-0">Quality of service</p>
                              <ul>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><span>5.0</span></li>
                              </ul>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
                              <p class="mb-0">Quality of service</p>
                              <ul>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><span>5.0</span></li>
                              </ul>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
                              <p class="mb-0">Quality of service</p>
                              <ul>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><span>5.0</span></li>
                              </ul>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                              <p class="mb-0">Quality of service</p>
                              <ul>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><span>5.0</span></li>
                              </ul>
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                              <p class="mb-0">Quality of service</p>
                              <ul>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><i></i></li>
                                <li><span>5.0</span></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Review Box -->
                    <div class="review-box d-md-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <span class="">5.0</span>
                        </div>
                        <span class="success-text"
                          ><i class="feather-check"></i>Yes, I would book again.</span
                        >
                        <h6>Absolutely Perfect</h6>
                        <p>
                          If you are looking for a perfect place for friendly matches with
                          your friends or a competitive match, It is the best place.
                        </p>
                        <coach-detail-image></coach-detail-image>
                        <span class="post-date">Sent on 11/03/2023</span>
                      </div>
                    </div>
                    <!-- /Review Box -->

                    <!-- Review Box -->
                    <div class="review-box d-md-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-06.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <span class="">5.0</span>
                        </div>
                        <span class="warning-text"
                          ><i class="feather-x"></i>No, I dont want to book again.</span
                        >
                        <h6>Awesome. Its very convenient to play.</h6>
                        <p>
                          If you are looking for a perfect place for friendly matches with
                          your friends or a competitive match, It is the best place.
                        </p>
                        <div class="dull-bg">
                          <p>
                            Experience badminton excellence at Badminton Academy.
                            Top-notch facilities, well-maintained courts, and a friendly
                            atmosphere. Highly recommended for an exceptional playing
                            experience
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- /Review Box -->
                    <div class="d-flex justify-content-center">
                      <button
                        type="button"
                        class="btn btn-load-more d-flex justify-content-center align-items-center"
                      >
                        Load More<i class="feather-plus-square"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion-item mb-0" id="location">
                <h4 class="accordion-header" id="panelsStayOpen-location">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseSeven"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseSeven"
                  >
                    Location
                  </button>
                </h4>
                <div
                  id="panelsStayOpen-collapseSeven"
                  class="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-location"
                >
                  <div class="accordion-body">
                    <div class="google-maps">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.8862835683544!2d-73.98256668525309!3d41.93829486962529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89dd0ee3286615b7%3A0x42bfa96cc2ce4381!2s132%20Kingston%20St%2C%20Kingston%2C%20NY%2012401%2C%20USA!5e0!3m2!1sen!2sin!4v1670922579281!5m2!1sen!2sin"
                        height="445"
                        style="border: 0"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                    <div
                      class="dull-bg d-flex justify-content-start align-items-center mb-0"
                    >
                      <div class="white-bg me-2">
                        <i class="fas fa-location-arrow"></i>
                      </div>
                      <div class="">
                        <h6>Our Venue Location</h6>
                        <p>70 Bright St New York, USA</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Accordian Contents -->
          </div>
          <coach-detail-sidebar></coach-detail-sidebar>
        </div>
        <!-- /Row -->
      </div>
      <!-- /container -->

      <section class="section innerpagebg">
        <div class="container">
          <div class="featured-slider-group">
            <h3 class="mb-40">Similar Coaches</h3>
            <div class="owl-carousel featured-venues-slider owl-theme">
              <similar-coaches></similar-coaches>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- /Page Content -->
  </div>

  <layout-footer></layout-footer>

  <coach-detail-modal></coach-detail-modal>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
